// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"370":"027cdc7d","429":"b71eb3c4","481":"d212d791","486":"fc10e420","716":"05aa80e8","739":"027cdc7d","978":"d212d791"}[chunkId] + ".chunk.css";
};